<script>
    import Collapse from './Collapse.svelte';
    import {formatTimestamp} from '../Utilities/time_format';
    import {clean} from '../Utilities/Cleaner.svelte';
    import markdown from '../Utilities/markdown';
    import {userMap} from '../Utilities/Session.svelte'
    export let notes;
    export let collapsed = true;

</script>

<Collapse title="Previous Notes" title_level=6 {collapsed}>
{#each notes as note (note._id)}
        <article class="media">
            <div class="media-content">
                <div class="content">
                    <p class="comment is-size-6">
                        <strong>{$userMap[note.user] || note.user}</strong>
                        <small>
                            {#if note.ts}
                                {formatTimestamp(note.ts)}
                            {:else}
                                {note.timestamp}
                            {/if}
                        </small>
                        <span class="tags">
                            {#each note.tags || [] as tag}
                                <span class="tag is-{tag.color_class}">{tag.name}</span>
                            {/each}
                        </span>
                        <span class="note">{@html clean(markdown(note.note))}</span>
                    </p>
                </div>
            </div>
        </article>
    {/each}
    <hr>
</Collapse>